export const SALUTATIONS = ["Mr.", "Mrs.", "Ms.", "Mx.", "Dr."];
export const PRONOUNS = ["he/him", "she/her", "they/them", "ze/hir", "xe/xem", "Other"];
export const ENROLLMENT = ["Active", "Pending", "Inactive"];
export const ETHNICITIES = ["Hispanic or Latino", "Not Hispanic or Latino", "White", "Black or African American", "Asian", "American Indian/Alaska Native", "Native Hawaiian/Pacific Islander", "Two or More Races", "Other", "Prefer not to say"];
export const SMOKING = ["Never Smoker", "Former Smoker", "Current Every Day Smoker", "Current Some Day Smoker", "Unknown"];
export const LANGUAGES = ["English", "Spanish", "French", "Mandarin", "Vietnamese", "Arabic", "ASL", "Other"];
export const RELIGIONS = ["Christianity", "Islam", "Judaism", "Buddhism", "Hinduism", "None", "Other", "Prefer not to say"];
export const EDUCATION = ["Less than High School", "High School / GED", "Some College", "Associate Degree", "Bachelor's Degree", "Graduate Degree", "Other"];
export const MILITARY = ["None", "Active Duty", "Veteran", "Reserves", "Military Family Member"];
export const CONTACT_TYPES = ["Home Phone", "Cell Phone", "Work Phone", "Email", "Other"];
export const RELATIONSHIPS = ["Mother", "Father", "Sister", "Brother", "Spouse", "Guardian", "Grandparent", "Child", "Friend", "Case Worker", "Other"];
export const SCHOOL_CONTACT_TYPES = ["Assigned Staff", "Principal", "Assistant Principal", "School Counselor", "Teacher", "Social Worker", "Other"];
export const ENTITY_TABS = [["family", "Family"], ["care_providers", "Care Providers"], ["referral_resources", "Referral Resources"], ["collateral", "Collateral Contact"]];
export const COMM_METHODS = ["Call", "Text", "Email", "Voicemail"];
export const PROGRAM_STATUSES = ["Screening", "Intake", "Active", "Discharged", "Waitlist"];

export const DEMO_DATE_FIELDS = [
  "MH Program Admission Date", "SUD Program Admission Date", "DD Program Admission Date", "Pre Admit Date", "TB Screening Date",
  "MH Referral Date", "SUD Referral Date", "DD Referral Date", "Scheduled Behavioral Health Assessment", "TB Reading Date",
  "MH Intake Date", "SUD Intake Date", "DD Intake Date", "First Scheduled Appointment for Treatment", "Medical Screening Date",
  "MH Discharge Date", "SUD Discharge Date", "DD Discharge Date", "First Scheduled MD Appointment Date", "Drug Screening Date",
  "Behavioral Health Assessment Date SUD", "STD Screening Date", "First OutClient Treatment Date", "Initial Psychiatric Evaluation Date",
];

export const STATUS_DATE_GROUPS = {
  referral: ["MH Referral Date", "SUD Referral Date", "DD Referral Date"],
  scheduling: ["Scheduled Behavioral Health Assessment"],
  preadmit: ["Pre Admit Date"],
  screening: ["TB Screening Date", "TB Reading Date", "Medical Screening Date", "Drug Screening Date", "STD Screening Date", "Behavioral Health Assessment Date SUD"],
  intake: ["MH Intake Date", "SUD Intake Date", "DD Intake Date"],
  tx_scheduling: ["First Scheduled Appointment for Treatment", "First Scheduled MD Appointment Date"],
  admission: ["MH Program Admission Date", "SUD Program Admission Date", "DD Program Admission Date"],
  treatment: ["First OutClient Treatment Date", "Initial Psychiatric Evaluation Date"],
  discharge: ["MH Discharge Date", "SUD Discharge Date", "DD Discharge Date"],
};

export const STATUS_DATE_RULES = {
  unprocessed: ["referral", "scheduling"],
  pending: ["referral", "scheduling", "preadmit", "screening", "intake", "tx_scheduling"],
  waitlist: ["referral", "scheduling", "preadmit", "screening", "intake"],
  active: ["referral", "scheduling", "preadmit", "screening", "intake", "tx_scheduling", "admission", "treatment", "discharge"],
  denied: ["referral", "scheduling", "preadmit", "screening"],
  inactive: ["referral", "scheduling", "preadmit", "screening", "intake", "tx_scheduling", "admission", "treatment", "discharge"],
};

export const GROUP_UNLOCK_HINT = {
  preadmit: "Pending (Pre-Admit)",
  screening: "Pending (Pre-Admit)",
  intake: "Pending (Pre-Admit)",
  tx_scheduling: "Pending (Pre-Admit)",
  admission: "Active",
  treatment: "Active",
  discharge: "Active",
};

export const fieldGroup = (field) => Object.keys(STATUS_DATE_GROUPS).find((g) => STATUS_DATE_GROUPS[g].includes(field));

export const STATUS_STAGE_NOTE = {
  unprocessed: "New referral - only referral and assessment scheduling dates apply at this stage.",
  pending: "Pre-admission - screening, intake, and treatment scheduling dates are now active. Admission, treatment, and discharge dates unlock at Active.",
  waitlist: "Waitlisted - screening and intake dates stay active while the client waits for an opening.",
  active: "Active episode - all program, treatment, and discharge dates are available.",
  denied: "Denied - referral and screening dates document the decision. Later-stage dates stay locked.",
  inactive: "Closed episode - the full historical record, including discharge dates, can be completed.",
};

const dates = {};
DEMO_DATE_FIELDS.forEach((f) => { dates[f] = ""; });

export const EMPTY_INTAKE = {
  demographics: {
    first_name: "", middle_name: "", last_name: "", salutation: "", nickname: "", pronouns: "",
    health_record_number: "", ssn: "", drivers_license: "", enrollment_status: "Active",
    address: "", city: "", state: "", zip: "", county: "",
    home_phone: "", work_phone: "", cell_phone: "", email: "",
    gender: "", ethnicity: "", dob: "", age: "",
    weight: "", height: "", smoking_status: "", preferred_language: "", marital_status: "", religion: "",
    education_level: "", employment: "", military: "",
    program_dates: dates,
    state_custody: "yes", literate: "yes", client_status: "unprocessed",
    transition_from_provider: false, transition_to_provider: false, deceased: false,
  },
  referral_source: { referring_person: "", agency_title: "", relationship: "", partner_type: "", agency_name: "", agency_website: "", address: "", business_phone: "", cell_phone: "", email: "" },
  insurance: { payer: "insurance", primary: { company: "", type: "", identification_number: "", group_number: "", effective_date: "", address: "", main_number: "", claims_number: "", fax: "", co_payment: "" }, secondary: { company: "", type: "", identification_number: "", group_number: "", effective_date: "", address: "", main_number: "", claims_number: "", fax: "", co_payment: "" } },
  requested_services: { request_types: [], services: [{ program: "", service: "", start_date: "" }], justification: "" },
  presenting_problem: { summary: "", answers: {}, mental_illness_specify: "", substance_use_specify: "" },
  diagnosis: { entries: [], primary_care_md: "", phone: "", characteristics: {} },
  medication: { active: [], discontinued: [], note: "", side_effects_severity: "", reconciliation_completed: false, medication_plan: "", additional_information: "" },
  housing: { placement: [], contact_name: "", relationship: "", facility_name: "", address: "", home_phone: "", mobile: "", email: "" },
  employer_school: { school: "", student_id: "", address: "", city: "", state: "", zip: "", county: "", district_name: "", district_id: "", contacts: [] },
  external_entities: { family: [], care_providers: [], referral_resources: [], collateral: [] },
  emergency: { contacts: [{ name: "", relationship: "", home_phone: "", cell_phone: "", contact_type: "", number: "" }], note: "" },
  permission_to_communicate: { entries: [{ name: "", relationship: "", methods: [] }], note: "" },
  call_portal: { contact_person: "", relationship: "", home_phone: "", cell_phone: "", alt_home_phone: "", address: "", city: "", state: "", zip: "", county: "", email: "", notes: "" },
  authorized_programs: { programs: [], levels_of_service: [], justification: "" },
};
